import { supabase } from '../lib/supabase';

// Convert DB snake_case to camelCase
const toCamel = (issue) => {
  if (!issue) return null;
  return {
    id: issue?.id,
    title: issue?.title,
    type: issue?.type,
    description: issue?.description,
    priority: issue?.priority,
    status: issue?.status,
    dueDate: issue?.due_date,
    requester: issue?.requester,
    createdBy: issue?.created_by,
    createdAt: issue?.created_at,
    updatedAt: issue?.updated_at,
  };
};

// Convert camelCase to DB snake_case
const toSnake = (issue) => {
  const record = {};
  if (issue?.title !== undefined) record.title = issue?.title;
  if (issue?.type !== undefined) record.type = issue?.type;
  if (issue?.description !== undefined) record.description = issue?.description;
  if (issue?.priority !== undefined) record.priority = issue?.priority;
  if (issue?.status !== undefined) record.status = issue?.status;
  if (issue?.dueDate !== undefined) record.due_date = issue?.dueDate || null;
  if (issue?.requester !== undefined) record.requester = issue?.requester;
  return record;
};

export const bugTrackerService = {
  async getAll() {
    const { data, error } = await supabase?.from('bug_issues')?.select('*')?.order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching bug issues:', error?.message);
      throw error;
    }
    return (data || [])?.map(toCamel);
  },

  async create(issueData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const record = {
      ...toSnake(issueData),
      created_by: user?.id || null,
    };

    const { data, error } = await supabase?.from('bug_issues')?.insert(record)?.select()?.single();

    if (error) {
      console.error('Error creating bug issue:', error?.message);
      throw error;
    }
    return toCamel(data);
  },

  async update(id, issueData) {
    const { data, error } = await supabase?.from('bug_issues')?.update(toSnake(issueData))?.eq('id', id)?.select()?.single();

    if (error) {
      console.error('Error updating bug issue:', error?.message);
      throw error;
    }
    return toCamel(data);
  },

  async remove(id) {
    const { error } = await supabase?.from('bug_issues')?.delete()?.eq('id', id);

    if (error) {
      console.error('Error deleting bug issue:', error?.message);
      throw error;
    }
  },

  subscribeToChanges(onInsert, onUpdate, onDelete) {
    const channel = supabase?.channel('bug_issues_realtime')?.on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'bug_issues' },
        (payload) => onInsert && onInsert(toCamel(payload?.new))
      )?.on(
        'postgres_changes',
        { event: 'UPDATE', schema: 'public', table: 'bug_issues' },
        (payload) => onUpdate && onUpdate(toCamel(payload?.new))
      )?.on(
        'postgres_changes',
        { event: 'DELETE', schema: 'public', table: 'bug_issues' },
        (payload) => onDelete && onDelete(payload?.old?.id)
      )?.subscribe();

    return channel;
  },

  unsubscribe(channel) {
    if (channel) supabase?.removeChannel(channel);
  },
};
